var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.35 220.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .accent {\n        fill: #3d56a6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M657.76,800H136.41c25.05-125.82,132.24-220.38,260.68-220.38S632.71,674.15,657.76,800Z",
    transform: "translate(-136.41 -579.59)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothes1);
export default __webpack_public_path__ + "static/media/clothes1.8d294ec7.svg";
export { ForwardRef as ReactComponent };